<template>
  <div class="spec-note-comp">
    <div class="spec-note-comp__title-container">
      <div class="spec-note-comp__title-purple-box">
      </div>
      <p
        class="spec-note-comp__title"
        tabindex="0"
        aria-label="Notowania specjalne"
      >
        Notowania specjalne
      </p>
    </div>
    <div
      class="spec-note-comp__banner-list"
      v-for="(banner, index) in bannerList"
      :key="index"
    >
      <Banner :photo="banner.photo" :site="banner.link"/>
    </div>
  </div>
</template>

<script>
  import Banner from '@/components/Banner/Desktop/Banner.vue';
  import mixin from '../mixin';

  export default {
    mixins: [mixin],
    components: {
      Banner
    }
  }
</script>

<style scoped lang="scss">
  .spec-note-comp {
    &__title-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 2rem;
    }
   
    &__title {
      margin-left: 6%;
      font-size: 1.25rem;
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;
      font-weight: bolder;
      position: relative;
      margin-top: 40px;
      display: inline-block;
      &:after {
        content: "";
        position: absolute;
        width: 1rem;
        height: 1rem;
        background-color: #df2860;
        left: -1.5rem;
        top: 6%;
      }
    }
  }
</style>
